import { queryClient } from '@/lib/react-query';
import {
  DeleteDTO,
  useDeleteMutationFactory,
  UseDeleteMutationProps,
} from '@/lib/react-query/delete';
import { Task } from '@/types';
import { remove } from '@/utils/api';
import { featureKeys, featurePath, TaskSearchParams } from '.';

export type DeleteTaskDTO = DeleteDTO<Task, TaskSearchParams>;

const deleteTask = ({ id, data, params }: DeleteTaskDTO) => remove(`${featurePath}/${id}`);

export const useDeleteTask = (options?: UseDeleteMutationProps<Task>) => {
  return useDeleteMutationFactory({
    invalidateKeys: featureKeys,
    mutationFn: deleteTask,
    onSuccess: (data) => {
      if (data.parent_task_id !== null) {
        queryClient.invalidateQueries({
          queryKey: [{ scope: 'task', entity: 'detail', id: data.parent_task_id }],
        });
        if (data.parent_task?.taskable_type && data.parent_task?.taskable_id) {
          queryClient.invalidateQueries({
            queryKey: [
              {
                scope: data.parent_task.taskable_type,
                entity: 'detail',
                id: data.parent_task.taskable_id,
              },
            ],
          });
        }
      }
    },
    ...options,
  });
};
